module.exports = __webpack_public_path__ + "c27b0ccd7fe8a4f7e13d06f9eb4f3859.png";